export default "__VITE_ASSET__7adc9cfc__"